<template>
  <b-card>
    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <b-col cols="12">
          <b-form-group label="Descrição" label-for="descricao">
            <b-form-input
              id="descricao"
              v-model="eventDiscount.descricao"
              required
              placeholder="Digite a descrição do desconto"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Evento" label-for="evento">
            <v-select
              id="evento"
              v-model="eventDiscount.evento"
              :options="eventos"
              label="nome"
              :reduce="(evento) => evento"
              placeholder="Selecione o evento"
            >
              <template #no-options>
                <div class="text-muted">Nenhum evento encontrado</div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Tipo" label-for="tipo">
            <v-select
              id="tipo"
              v-model="eventDiscount.tipo"
              :options="tipos"
              label="descricao"
              :reduce="(tipo) => tipo"
              placeholder="Selecione o tipo"
            >
              <template #no-options>
                <div class="text-muted">Nenhum tipo encontrado</div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Tipo de Registro" label-for="tipoRegistro">
            <v-select
              id="tipoRegistro"
              v-model="eventDiscount.tipoRegistro"
              :options="tiposRegistro"
              label="descricao"
              :reduce="(tipo) => tipo"
              placeholder="Selecione o tipo de registro"
            >
              <template #no-options>
                <div class="text-muted">Nenhum tipo de registro encontrado</div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            label="Percentual de Desconto"
            label-for="percentualDesconto"
          >
            <b-form-input
              id="percentualDesconto"
              v-model="eventDiscount.percentualDesconto"
              type="number"
              min="0"
              max="100"
              placeholder="0-100"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group label="Valor do Desconto" label-for="valorDesconto">
            <money
              id="valorDesconto"
              v-model="eventDiscount.valorDesconto"
              v-bind="money"
              class="form-control"
              placeholder="0,00"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-checkbox
            id="ativo"
            v-model="eventDiscount.ativo"
            name="ativo"
            switch
          >
            {{ eventDiscount.ativo ? "Ativo" : "Inativo" }}
          </b-form-checkbox>
        </b-col>

        <!-- submit and reset -->
        <ButtonsFormVue
          :permission-insert="verificarPermissao('ROLE_ADMIM_INSERIR')"
          :permission-edit="verificarPermissao('ROLE_ADMIM_ATUALIZAR')"
          :disable-form="false"
          @save="save()"
          @cancel="cancel()"
        />
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import { mapState } from "vuex";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from "bootstrap-vue";
import { Money } from "v-money";
import mixinsGlobal from "@/mixins";
import vSelect from "vue-select";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
import Ripple from "vue-ripple-directive";
import { verificarPermissao } from "@/auth/utils";

export default {
  name: "EventDiscountForm",
  components: {
    Money,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    BFormCheckbox,
    vSelect,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      verificarPermissao,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
      // These should be loaded from your API
      eventos: [],
      tipos: [],
      tiposRegistro: [],
    };
  },
  computed: {
    ...mapState("eventDiscountSettingsModule", {
      eventDiscount: (state) => state.eventDiscount,
    }),
  },
  created() {
    this.loadDependencies();
  },
  methods: {
    async loadDependencies() {
      try {
        // TODO: Replace with actual API calls
        // this.eventos = await this.$http.get('/api/eventos');
        // this.tipos = await this.$http.get('/api/tipos');
        // this.tiposRegistro = await this.$http.get('/api/tipos-registro');
      } catch (error) {
        console.error("Error loading dependencies:", error);
      }
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.eventDiscount.id) {
            this.$store.dispatch(
              "eventDiscountSettingsModule/editEventDiscount",
              this.eventDiscount
            );
          } else {
            this.$store.dispatch(
              "eventDiscountSettingsModule/insertNewEventDiscount",
              this.eventDiscount
            );
          }
        }
      });
    },
    cancel() {
      this.$emit("cancelar");
      this.cleanObjeto();
      this.$store.dispatch("eventDiscountSettingsModule/resetEventDiscount");
    },
    cleanObjeto() {
      this.eventDiscount = {
        id: null,
        nome: "",
        ativo: true,
      };
    },
  },
};
</script>
